<section>
  <main *ngIf="this.trans" class="grid p-fluid col-12 lg:col-8">
    
    <!-- Información de Pago Section -->
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.pago }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else pago">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #pago>
          <p>{{ data.pago }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.vigencia }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else vigencia">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #vigencia>
          <p>{{ data.vigencia }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.periodo }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else periodo">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #periodo>
          <p>{{ data.periodo }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.banco }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else banco">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #banco>
          <p>{{ data.banco }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.medioPago }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else medioPago">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #medioPago>
          <p>{{ data.medioPago }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.fechaPago }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else fechaPago">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #fechaPago>
          <p>{{ data.fechaPago | date: defaultDateFormat }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.impuesto }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else impuesto">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #impuesto>
          <p>{{ data.impuesto }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.concepto }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else concepto">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #concepto>
          <p>{{ data.concepto }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-4">
      <div>
        <b>{{ trans.nombreTramite }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else nombreTramite">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #nombreTramite>
          <p>{{ data.nombreTramite }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div>
        <b>{{ trans.totalPago }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else totalPago">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #totalPago>
          <p>{{ data.totalPago | currency }}</p>
        </ng-template>
      </div>
    </div>
    <div class="col-12 md:col-6 lg:col-4">
      <div>
        <b>{{ trans.valorAplicadoConcepto }}:</b>
      </div>
      <div>
        <p *ngIf="isLoading; else valorAplicadoConcepto">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #valorAplicadoConcepto>
          <p>{{ data.valorAplicadoConcepto | currency }}</p>
        </ng-template>
      </div>
    </div>
  </main>
</section>